import React, { Component } from 'react';
import { Base64 } from 'js-base64';
import ContentSection from '../ContentSection';
import Navbar from '../Navbar';
import './styles.css';

export default class LoginPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: ''
    };
  }

  render() {
    return (
      <Navbar location={this.props.location}>
        <div className="login-page">
          <ContentSection>
            <div className="login-form">
              <h1>Login</h1>
              <div className="login-row">
                <div>Email:</div>
                <input type="email" value={this.state.email} onChange={this._handleEmailChange}/>
              </div>
              <div className="login-row">
                <div>Password:</div>
                <input type="password" value={this.state.password} onChange={this._handlePasswordChange}/>
              </div>
              <button disabled={!(this.state.email.trim() && this.state.password.trim())} onClick={this._handleSubmission}>Login</button>
            </div>
          </ContentSection>
        </div>
      </Navbar>
    );
  }

  _handleEmailChange = (event) => this.setState({ email: event.target.value });

  _handlePasswordChange = (event) => this.setState({ password: event.target.value });

  _handleSubmission = async () => {

    const token = Base64.encode(`${this.state.email}:${this.state.password}`);
    const response = await fetch('/api/v1/auth/token', {
      headers: {
        Authorization: `Basic ${token}`
      }
    });
    if (response.ok) {
      window.location.href = '/admin';
    } else {
      if (response.status === 401) {
        alert(`Nope - this username and password doesn't work. Did you forget your password?`);
      } else {
        alert(`Shooooot - the server returned an unexpected error. Better call Nate! (status code ${response.status})`);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginPage/index.js